import "./App.css";
import { PrimeReactProvider } from "primereact/api";
import AirGold from "./pages/AirGold";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./pages/Home";
import Kolorovi from "./pages/Kolorovi";
// import Billion from "./pages/Billion";
// import Harmony from "./pages/Harmony";
import Vidrodzhennya from "./pages/Vidrodzhennya";
import Reflect from "./pages/Reflect";
import Diamonds from "./pages/diamonds/Diamonds";
import NotFound from "./pages/NotFound";
import StatsPage from "./pages/StatsPage";
import Billion from "./pages/billion/Billion";
import Harmony from "./pages/Harmony";
import Catalog from "./pages/catalog/Catalog";
import Exchange from "./pages/exchange/Exchange";
import Product from "./pages/product/Product";
import Basket from "./pages/basket/Basket";
import AboutUs from "./pages/AboutUs";
import Delivery from "./pages/Delivery";
import Luxury from "./pages/luxury/Luxury";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Home />,
    },
    {
        path: "/air-gold",
        element: <AirGold />,
        // children: [
        //     {
        //         index: true,
        //         element: <AirGold />,
        //     },
        //     {
        //         path: ":userId",
        //         element: <Product />,
        //     },
        // ],
    },
    {
        path: "/kolorovi",
        element: <Kolorovi />,
    },
    {
        path: "/exchange",
        element: <Exchange />,
    },
    {
        path: "/billion",
        element: <Billion />,
    },
    {
        path: "/harmony",
        element: <Harmony />,
    },
    {
        path: "/vidrodzhennya",
        element: <Vidrodzhennya />,
    },
    {
        path: "/reflect",
        element: <Reflect />,
    },
    {
        path: "/diamonds",
        element: <Diamonds />,
    },
    {
        path: "/stats",
        element: <StatsPage />,
    },
    {
        path: "/catalog",
        element: <Catalog />,
    },
    {
        path: "/basket",
        element: <Basket />,
    },
    {
        path: "/catalog/:collection/:id",
        element: <Product />,
    },
    {
        // Fallback for old URLs without collection
        path: "/catalog/:id",
        element: <Product />,
    },
    {
        path: "/about-us",
        element: <AboutUs />,
    },
    {
        path: "/delivery",
        element: <Delivery />,
    },
    {
        path: "/luxury",
        element: <Luxury />,
    },
    {
        // Catch-all route for 404
        path: "*",
        element: <NotFound />,
    },
]);

function App() {
    return (
        <div className="bg-darkgray h-full w-full flex flex-col justify-center max-w-[1440px]">
            <PrimeReactProvider>
                <RouterProvider router={router} />
            </PrimeReactProvider>
        </div>
    );
}

export default App;
